import { useLogin } from '#src/@connections/use-login.js';
import React, { useEffect, useState } from 'react';
import Input from '#lib/components/input.jsx';
import Dialog from '#lib/components/dialog.jsx';
import Button from '#lib/components/button.jsx';
import { useForm } from '#lib/hooks/use-form.js';
import { addClasses } from '#lib/helpers/class.js';
import useBillingInfo from '#routes/settings/billing/use-billing-info.js';

export default function ConnectionsModal(props) {
    const { connections, isShown, onClose, country } = props;

    const [errorMessage, setErrorMessage] = useState('');
    const [hasError, setHasError] = useState(false);

    const connectAsyncOptions = {
        onSuccess: (res) => {
            if (!res.ok) {
                setHasError(true);
                setErrorMessage(res);
            } else {
                onClose();
            }
        },
        onError: (data) => {
            setHasError(true);
            data ? setErrorMessage(data.message) : setErrorMessage('Something went wrong, retry.');
        }
    };
    const connectFn = useLogin(connectAsyncOptions);
    const form = useForm({
        onSubmit: async (data) => {
            data.connectionId = data.connectionId.toLowerCase();
            data.url = connections.find((connection) => connection.connectionId === data.connectionId).loginEndpoint;
            connectFn.execute({ data, country });
        }
    });

    return (
        <Dialog
            isOpen={isShown}
            onClose={() => {
                setHasError(false);
                setErrorMessage('');
                onClose();
            }}
            className="h-screen flex items-center justify-center fixed inset-4"
        >
            <Dialog.Panel className="flex flex-col gap-4">
                <div className="pr-8">
                    <Dialog.CloseButton />
                    <p className="text-2xl">{_t.connections.connect()}</p>
                    {hasError ? (
                        <p className="text-sm">{errorMessage}</p>
                    ) : (
                        <p className="text-sm">{_t.connections.credentialsDisclosure()}</p>
                    )}
                </div>
                <form {...form.props.form}>
                    <div className="flex flex-col gap-2">
                        <Input.Full
                            hasError={hasError}
                            form={form.props.form.id}
                            className="w-full"
                            type="text"
                            label={_t.connections.connectionId()}
                            name="connectionId"
                            autoComplete="false"
                            required={true}
                        />
                        <Input.Full
                            hasError={hasError}
                            form={form.props.form.id}
                            className="w-full"
                            type="text"
                            label={_t.connections.username()}
                            name="username"
                            autoComplete="false"
                            required={true}
                        />
                        <Input.Full
                            hasError={hasError}
                            form={form.props.form.id}
                            className="w-full"
                            type="password"
                            label={_t.connections.password()}
                            name="password"
                            required={true}
                        />
                    </div>

                    <div>
                        <Button className={addClasses('mt-4 float-right')} busy={connectFn.isLoading} type="submit">
                            {_t.connections.confirm()}
                        </Button>
                    </div>
                </form>
            </Dialog.Panel>
        </Dialog>
    );
}
